module.exports = __webpack_public_path__ + "static/media/teeth.b503f377.svg";